<div class="preview-fields">
  <div class="preview-field" *ngFor="let field of fields">
    <div class="field-title">
      {{ field.fieldTitle || field.name }}
      <span class="required-mark" *ngIf="field.required">*</span>
    </div>
    <div class="field-description" *ngIf="field.fieldDescription">{{ field.fieldDescription }}</div>

    <ng-container [ngSwitch]="field.type">

      <!-- Texto corto -->
      <input *ngSwitchCase="'input_text'" class="preview-input" type="text"
             [placeholder]="field.inputConfig?.placeholder || ''"
             [attr.maxlength]="field.inputConfig?.maxLength"
             [ngModel]="getValue(field)" (ngModelChange)="setValue(field, $event)" />

      <!-- Área de texto -->
      <textarea *ngSwitchCase="'input_text_area'" class="preview-input" rows="3"
                [placeholder]="field.inputConfig?.placeholder || ''"
                [attr.maxlength]="field.inputConfig?.maxLength"
                [ngModel]="getValue(field)" (ngModelChange)="setValue(field, $event)"></textarea>

      <!-- Select -->
      <select *ngSwitchCase="'select'" class="preview-input"
              [ngModel]="getValue(field)" (ngModelChange)="setValue(field, $event)">
        <option [ngValue]="undefined" disabled selected>Selecciona...</option>
        <option *ngFor="let option of field.options" [value]="option.option">{{ option.option }}</option>
      </select>

      <!-- Radio -->
      <div *ngSwitchCase="'radio'" class="option-grid">
        <button type="button" class="option-card" *ngFor="let option of field.options"
                [class.selected]="isSelected(field, option.option)"
                (click)="setValue(field, option.option)">
          <img *ngIf="option.imageUrl" [src]="option.imageUrl" alt="" />
          <span>{{ option.option }}</span>
        </button>
      </div>

      <!-- Multiselect -->
      <div *ngSwitchCase="'multiselect'" class="option-grid">
        <button type="button" class="option-card" *ngFor="let option of field.options"
                [class.selected]="isSelected(field, option.option)"
                (click)="toggleMultiselect(field, option.option)">
          <img *ngIf="option.imageUrl" [src]="option.imageUrl" alt="" />
          <span>{{ option.option }}</span>
        </button>
      </div>

      <!-- Checkbox -->
      <div *ngSwitchCase="'checkbox'" class="option-grid">
        <label class="checkbox-row" *ngFor="let option of field.options">
          <input type="checkbox"
                 [checked]="isSelected(field, option.option)"
                 (change)="toggleMultiselect(field, option.option)" />
          <span>{{ option.option }}</span>
        </label>
      </div>

      <!-- Confirmación -->
      <div *ngSwitchCase="'confirmation'" class="confirmation-row">
        <button type="button" class="confirmation-button" *ngFor="let option of confirmationOptions(field)"
                [class.selected]="getValue(field) === option"
                (click)="setValue(field, option)">
          {{ option }}
        </button>
      </div>

      <!-- Contador -->
      <div *ngSwitchCase="'counter'" class="counter-row">
        <button type="button" class="counter-button" (click)="incrementCounter(field, -1)">
          <mat-icon>remove</mat-icon>
        </button>
        <span class="counter-value">{{ counterValue(field) }}</span>
        <button type="button" class="counter-button" (click)="incrementCounter(field, 1)">
          <mat-icon>add</mat-icon>
        </button>
      </div>

      <!-- Fotos: el selector real lo resuelve el app móvil -->
      <div *ngSwitchCase="'photos'" class="photos-row">
        <div class="photo-slot" *ngFor="let slot of photoSlots">
          <mat-icon>add_a_photo</mat-icon>
        </div>
      </div>

      <div *ngSwitchDefault class="unknown-type">Tipo no soportado: {{ field.type }}</div>
    </ng-container>

    <!-- Dependencias activas -->
    <div class="nested-preview" *ngIf="activeDependencies(field).length">
      <app-form-preview [fields]="activeDependencies(field)"></app-form-preview>
    </div>
  </div>

  <p class="empty" *ngIf="!fields.length">Agrega campos para ver la vista previa</p>
</div>
